<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">{{ $t('finance.banksTitle') }}</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{
            add_bank: 'add_bank'
          }"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :addBankButton="true"
          :openAddBankModal="openAddBankModal"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
            <tr
              v-for="r in apiResults"
              :key="r.bank_id"
            >
              <td>{{ r.bank_id }}</td>
              <td>{{ r.bank_name }}</td>
              <td>{{ r.initial_balance }}</td>
              <td>{{ r.balance }}</td>
              <td>{{ r.created_at }}</td>
              <td>
                <a
                  v-if="$_has_perm('edit_bank')"
                  :tooltip="$t('common.edit')"
                  @click="openEditBankModal(r)"
                >
                  <v-icon color="blue darken-2">edit</v-icon>
                </a>
                <a
                  v-if="$_has_perm('delete_bank')"
                  :tooltip="$t('common.delete')"
                  @click="deleteBank(r.bank_id)"
                >
                  <v-icon color="red darken-2">delete</v-icon>
                </a>
              </td>
            </tr>
            <tr id="no-result-row">
              <td
                :colspan="columns.length"
                class="text-center"
              >
                <v-alert
                  type="error"
                  :value="alertValue"
                >
                  {{ $t('common.noResultsFound') }}
                </v-alert>
              </td>
            </tr>
            </tbody>
          </datatable>

          <add-bank
            :addBankModal="addBankModal"
            :closeAddBankModal="closeAddBankModal"
            :addBankData="addBankData"
            :addBank="addBank"
            :checkAlert="checkAlert"
          ></add-bank>

          <edit-bank
            :editBankModal="editBankModal"
            :closeEditBankModal="closeEditBankModal"
            :editBankData="editBankData"
            :editBank="editBank"
            :checkAlert="checkAlert"
            :errorAlert="errorAlert"
          ></edit-bank>

          <hr/>
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import mobileDatatable from '../mobileDatatable'
import addBank from './addBank'
import editBank from './editBank'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'mobile-datatable': mobileDatatable,
    'add-bank': addBank,
    'edit-bank': editBank
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      {label: this.$t('columns.id'), text: this.$t('columns.id'), value: '1', sortable: true, searchable: true, name: 'bank_id'},
      {
        label: this.$t('columns.bankName'),
        text: this.$t('columns.bankName'),
        value: '2',
        sortable: true,
        searchable: true,
        name: 'bank_name'
      },
      {
        label: this.$t('columns.initialBalance'),
        text: this.$t('columns.initialBalance'),
        value: '3',
        sortable: true,
        searchable: true,
        name: 'initial_balance'
      },
      {
        label: this.$t('columns.balance'),
        text: this.$t('columns.balance'),
        value: '4',
        sortable: true,
        searchable: false,
        name: 'balance'
      },
      {
        label: this.$t('columns.createDate'),
        text: this.$t('columns.createDate'),
        value: '5',
        sortable: true,
        searchable: true,
        name: 'created_at'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      url: 'api/banks',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      btnsave: true,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      addBankModal: false,
      editBankModal: false,
      theBankID: '',
      prevSearchQuery: '',
      apiResults: [],
      addBankData: {
        bank_name: '',
        initial_balance: 0
      },
      editBankData: {
        bank_name: '',
        initial_balance: 0
      },
      columns: columns,
      sortKey: 'bank_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    openAddBankModal() {
      this.addBankModal = true
    },

    closeAddBankModal() {
      this.addBankModal = false
      this.checkAlert = false
      this.clearAddBankModal()
    },

    clearAddBankModal() {
      this.addBankData.bank_name = ''
      this.addBankData.initial_balance = 0
    },

    addBank() {
      let token = localStorage.getItem('access_token')

      axios
        .post(this.url, this.addBankData, {headers: {Authorization: 'Bearer ' + token}})
        .then(response => {
          this.checkAlert = true
          this.clearAddBankModal()
          this.getResults()
        })
        .catch(() => {
        })
    },

    openEditBankModal(bank) {
      this.editBankData.bank_name = bank.bank_name
      this.editBankData.initial_balance = bank.initial_balance
      this.theBankID = bank.bank_id
      this.editBankModal = true
    },

    closeEditBankModal() {
      this.editBankModal = false
      this.checkAlert = false
      this.errorAlert = false
      this.clearEditBankModal()
    },

    clearEditBankModal() {
      this.editBankData.bank_name = ''
      this.editBankData.initial_balance = 0
    },

    editBank() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.url + '/' + this.theBankID, this.editBankData, {
          headers: {Authorization: 'Bearer ' + token}
        })
        .then(response => {
          this.errorAlert = false
          this.checkAlert = true
          this.clearEditBankModal()
          this.getResults()
        })
        .catch(() => {
          this.checkAlert = false
          this.errorAlert = true
        })
    },

    deleteBank(id) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.url + '/' + id, {headers: {Authorization: 'Bearer ' + token}})
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(() => {
            })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')
      //   let noResultRow = $('#no-result-row')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, {params: this.tableData, headers: {Authorization: 'Bearer ' + token}})
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => {
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}

a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/banks.vue